/**
 * Name rules shared by the core API (which refuses a bad value) and the web
 * client's inline field checks, so both give the same answer.
 */

/** A workspace name: required, and short enough for the workspace menu. */
export const WORKSPACE_NAME_MAX_LENGTH = 64;

/** A team name, trimmed: required, and between these bounds. The API also
 *  refuses a name another team holds in any letter case. */
export const TEAM_NAME_MIN_LENGTH = 3;
export const TEAM_NAME_MAX_LENGTH = 64;

/** A username is one word: letters, digits, dots, hyphens and underscores. */
export const USERNAME_MAX_LENGTH = 32;

const USERNAME_PATTERN = /^[\p{L}\p{N}._-]+$/u;

/** Why a username breaks the rule, or null when it passes. Empty is not
 *  checked here: the caller decides whether empty clears the username. */
export function usernameProblem(username: string): string | null {
  if (username.length > USERNAME_MAX_LENGTH) {
    return `Username must be at most ${USERNAME_MAX_LENGTH} characters.`;
  }
  if (!USERNAME_PATTERN.test(username)) {
    return "Use only letters, numbers, dots, hyphens and underscores, with no spaces.";
  }
  return null;
}
